/**
 * 공통 API 헤더 설정
 * 모든 API 요청에서 사용되는 기본 헤더들을 정의합니다.
 */
export const DEFAULT_HEADERS = {
  "x-time-zone": "Asia/Seoul",
  "x-device-model": "web",
  "x-unique-id": "client-uuid",
  "Accept-Language": "ko-KR",
  "Accept": "application/json",
} as const;

/**
 * 멀티파트 폼 데이터용 헤더 (Content-Type은 브라우저가 자동 설정)
 */
export const MULTIPART_HEADERS = {
  ...DEFAULT_HEADERS,
  // Content-Type은 FormData 사용시 브라우저가 자동으로 설정
} as const;

/**
 * JSON 요청용 헤더
 */
export const JSON_HEADERS = {
  ...DEFAULT_HEADERS,
  "Content-Type": "application/json",
} as const;
